(function () {
  'use strict';
  let mounted = false;
  function mount() {
    const cart = window['xo-webcomponents'];
    if (mounted || !window.discountNinja?.api || !cart?.cartSubscribe) return;
    mounted = true;
    const roots = 'xo-cart, xo-cart-mini';
    const controls = 'xo-cart-quantity-minus, xo-cart-quantity-plus, xo-cart-remove, input[name="quantity"], [name="checkout"]';
    const express = '.cart-actions__dynamic-checkout-buttons, .shopify-payment-button__buy';
    const saved = new Map();
    let nativeBusy = false;
    let appBusy = false;
    let pricingBusy = false, pricingTimer = 0;
    let recoveryRequired = false;
    const busy = () => nativeBusy || appBusy || pricingBusy || recoveryRequired;
    function lock(control) {
      if (!saved.has(control)) saved.set(control, {
        disabled: control.disabled,
        readOnly: control.readOnly,
        inert: control.inert,
        aria: control.getAttribute('aria-disabled')
      });
      if ('disabled' in control && control.name !== 'quantity') control.disabled = true;
      if ('readOnly' in control) control.readOnly = true;
      if (control.matches(express)) control.inert = true;
      if (control.getAttribute('aria-disabled') !== 'true') control.setAttribute('aria-disabled', 'true');
    }
    function render() {
      document.querySelectorAll('[data-cg-cart-recovery]').forEach(notice => { notice.hidden = !recoveryRequired; });
      if (busy()) document.querySelectorAll(express).forEach(lock);
      if (recoveryRequired) document.querySelectorAll('xo-cart-add, xo-cart-add button').forEach(lock);
      document.querySelectorAll(roots).forEach(root => {
        root.classList.toggle('cg-dn-cart--busy', busy());
        root.classList.toggle('cg-dn-cart--failed', recoveryRequired);
        root.classList.toggle('cg-dn-cart--pricing', pricingBusy && !recoveryRequired);
        if ((busy() || pricingBusy) && !recoveryRequired && root.getAttribute('aria-busy') !== 'true') root.setAttribute('aria-busy', 'true');
        else if ((!busy() && !pricingBusy || recoveryRequired) && root.hasAttribute('aria-busy')) root.removeAttribute('aria-busy');
        if (busy()) root.querySelectorAll(controls).forEach(lock);
      });
      for (const [control, original] of saved) {
        if (busy() && control.isConnected) continue;
        if (original.disabled !== undefined) control.disabled = original.disabled;
        if (original.readOnly !== undefined) control.readOnly = original.readOnly;
        if (original.inert !== undefined) control.inert = original.inert;
        if (original.aria === null) control.removeAttribute('aria-disabled');
        else control.setAttribute('aria-disabled', original.aria);
        saved.delete(control);
      }
    }
    function guard(event) {
      const failedAdd = recoveryRequired && (event.target.closest('xo-cart-add')
        || (event.type === 'submit' && event.target.querySelector('xo-cart-add')));
      if (!failedAdd && (!busy() || !event.target.closest(roots))) return;
      if (!failedAdd && event.type !== 'submit' && !event.target.closest(controls)) return;
      if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    ['click', 'keydown', 'submit'].forEach(type => document.addEventListener(type, guard, true));
    function nativeChanged(state) {
      nativeBusy = state.changeLineLoading !== -1 || Boolean(state.addIdLoading);
      // A rejected request can leave the app queue pending. Re-enter the cart
      // through a fresh document; never retry an ambiguous mutation automatically.
      if (!nativeBusy && (state.changeErrorMessage || state.addErrorMessage)) recoveryRequired = true;
      render();
    }
    cart.cartSubscribe(nativeChanged);
    document.addEventListener('la:dn:cart-mutations:processing', () => {
      appBusy = true;
      pricingBusy = true;
      window.clearTimeout(pricingTimer);
      pricingTimer = window.setTimeout(() => { recoveryRequired = true; render(); }, 30000);
      render();
    });
    document.addEventListener('la:dn:cart-mutations:processed', () => { appBusy = false; render(); });
    document.addEventListener('cg:cart-pricing:ready', () => {
      pricingBusy = false;
      window.clearTimeout(pricingTimer);
      render();
    });
    new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1
        && (node.matches(roots + ', ' + controls + ', ' + express + ', xo-cart-add, [data-cg-cart-recovery]')
          || node.querySelector(roots + ', ' + controls + ', ' + express + ', xo-cart-add, [data-cg-cart-recovery]'))))) render();
    }).observe(document.documentElement, { childList: true, subtree: true });
    nativeChanged(cart.getCartState());
  }
  document.addEventListener('la:dn:api:ready', mount);
  mount();
})();
